'use strict'
module.exports = require('pino-http')
